module.exports = __webpack_public_path__ + "static/media/Impact.f99fcd1d.svg";